import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Col, Form, Image, Input, Row, Steps, Switch, Tooltip } from "antd";
import Loading from "../../../auxiliary/loader/loading";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import { useEffect, useRef, useState } from "react";
import {
  ExportDocument,
  base64ToFile,
  delay,
  exportNormalFile,
  fileToformData,
  isEmptyObject,
  mergeSignatureWithBackground,
  urltoFile,
  validateInput,
} from "../../../../tools/tools";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { Content } from "antd/es/layout/layout";
import { useLayout } from "../../../layouts/layout";
import CSPrint from "../../../changeSimCard/updateDocument/cs-print";
import DALayout from "../da-layout";
import "./daDocument.scss";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import PrintDocument from "../../../simcardPurchase/print/printDocument";
import { useSelector } from "react-redux";
import { Roles } from "../../../../tools/services";
import ReactSignatureCanvas from "react-signature-canvas";
import { renderToString } from "react-dom/server";

import { isMobile, isTablet } from "react-device-detect";

const DADocument = () => {
  const [t] = useTranslation("global");
  const { setLayout } = useLayout();
  const [isLoading, setIsLoading] = useState(false);
  const formData = useSelector((state) => state);
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  // const [isDisabled, setIsDisabled] = useState(true);

  const [frmDocument] = Form.useForm();
  const [frmEmail] = Form.useForm();
  const { addDocument } = useAPIPublic();
  const { simSwap } = useDealer();
  const nav = useNavigate();
  const location = useLocation();

  const [signature, setSignature] = useState(false);

  const [bgSingature, setBgSingature] = useState("");
  const [printData, setPrintData] = useState(false);
  const refBox = useRef("");

  const [isEmail, setIsEmail] = useState(false);

  const [hasErrorSign, setHasErrorSign] = useState();

  useEffect(() => {
    if (!isEmptyObject(location?.state)) {
      // setLayout(<CSPrint print={{ ...location?.state?.purchase, kitno: location?.state?.kitNo, msisdn: location?.state?.daChange?.aptelMSIDSN }} />);

      var print = {
        spbundle: {
          bundleType: location?.state?.purchase?.inT_MSISDNStatusType,
        },
        spMsisdn: [{ msisdn: location?.state?.purchase?.inT_MSISDN }],
        spKit: location?.state?.kitNo,
        profile: {
          fname: location?.state?.purchase?.stR_FName,
          lname: location?.state?.purchase?.stR_LName,
          fathername: location?.state?.purchase?.stR_FatherName,
          certno: location?.state?.purchase?.stR_CertNo,
          birthdate: location?.state?.purchase?.dtE_BirthDate,
          txtCountry: "",
          gender: location?.state?.purchase?.inT_Gender,
          email: location?.state?.purchase?.stR_Email,
          postalcode: location?.state?.purchase?.address?.stR_PostalCode,
          txtProvince: location?.state?.purchase?.province?.stR_ProvinceName,
          txtCity: location?.state?.purchase?.city?.stR_CityName,
          mainstreet: location?.state?.purchase?.address?.stR_MainStreet,
          buildingno: location?.state?.purchase?.address?.stR_BuildingNo,
          floor: location?.state?.purchase?.address?.stR_Floor,
        },
        branchcode: formData?.another?._currentUser?.branchcode,
      };

      setSignature(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false);
      if (!(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false)) {
        setLayout(<PrintDocument print={{ ...print }} />);
      } else {
        setPrintData(print);
      }
    } else {
      // nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid);
    }
  }, [isMobile, isTablet]);

  const handleSubmit = async (values) => {
    setIsLoading(true);

    let validemail = await frmEmail.validateFields();
    if (isEmail) {
      if (!validemail) {
        setIsLoading(false);
        return false;
      }
    }

    if (values?.photo?.size > 0) {
      let resDoc = await addDocument(await fileToformData(values.photo), "SWDocument");
      if (resDoc) {
        let payload = {
          msisdn: location?.state?.daChange?.aptelMSIDSN,
          swapnationalid: location?.state?.purchase?.gudfK_CertNoDocumentId,
          swapdocumentid: resDoc?.Result,
          newiccid: location?.state?.kitNo,
          simswapreason: 0,
          email: isEmail ? validemail?.email : undefined,
          planid:process.env.REACT_APP_PLANID_DELIVERY_AREA
        };
        let response = await simSwap(payload);
        if (response) {
          nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Final, {
            state: {
              daChange: {
                Date: response?.dteDateTime,
                ServiceType: response?.serviceType,
                MSISDN: response?.msisdn,
                NEWICCID: response?.iccIdNew,
                StrFollwUpCode: response?.strFollwUpCode,
              },
            },
          });
        }
      }
    } else {
      let payload = {
        msisdn: location?.state?.daChange?.aptelMSIDSN,
        swapnationalid: location?.state?.purchase?.gudfK_CertNoDocumentId,
        swapdocumentid: null,
        newiccid: location?.state?.kitNo,
        simswapreason: 0,
        planid:process.env.REACT_APP_PLANID_DELIVERY_AREA
      };
      let response = await simSwap(payload);
      if (response) {
        nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Final, {
          state: {
            daChange: {
              Date: response?.dteDateTime,
              ServiceType: response?.serviceType,
              MSISDN: response?.msisdn,
              NEWICCID: response?.iccIdNew,
              StrFollwUpCode: response?.strFollwUpCode,
            },
          },
        });
      }
    }

    setIsLoading(false);
  };

  const handleGetImage = async (value) => {
    frmDocument.setFieldValue("photo", value);
  };
  const handleGetCanvas = (img) => {
    setBgSingature(img);
  };

  useEffect(() => {
    const setChangeCanvas = () => {
      if (bgSingature) {
        let canvas = document.getElementById("canvasDoc");
        let parentElement = canvas.parentElement;
        canvas.width = parentElement.clientWidth;
        canvas.height = parentElement.clientHeight;
      }
    };
    setChangeCanvas();
    window.addEventListener("orientationchange", setChangeCanvas);

    return () => {
      window.removeEventListener("orientationchange", setChangeCanvas);
    };
  }, [bgSingature]);

  const clearHandler = () => {
    let canvas = document.getElementById("canvasDoc");
    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    frmDocument.setFieldValue("photo", null);
  };
  const writeSignatureHandler = async () => {
    const signatureCanvas = document.getElementById("canvasDoc");
    const imgData = await mergeSignatureWithBackground(bgSingature, signatureCanvas);
    frmDocument.setFieldValue("photo", await base64ToFile(imgData));
  };
  return (
    <>
      <DALayout>
        <div className="container-main container-da">
          <div className="g-hold-title-of-page">
            <Breadcrumb
              className="breadcrumbs"
              items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("deliveryArea.title") }]}
            />
            <div className="title-page">
              <h3>{t("deliveryArea.title")}</h3>
              <p></p>
            </div>
          </div>
          <div className="g-layout-content">
            <Content className="g-layout-main da-container">
              <div className="g-format-page">
                <div className="g-body-format-page">
                  <div className="g-format-steps">
                    <div className="holder-step">
                      <Steps
                        size="small"
                        className="step-wizard"
                        current={2}
                        responsive
                        items={[
                          {
                            title: "احراز هویت",
                          },
                          {
                            title: "شماره کیت جدید",
                          },
                          {
                            title: "سند",
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="holder-document-page">
                    <div className="holder-document">
                      {signature ? (
                        <>
                          <div className="item-step">
                            <br />
                            <Form layout="vertical" form={frmEmail}>
                              <Row>
                                <Col xxl={8}>
                                  <Form.Item label="">
                                    <Row gutter={30}>
                                      <Col>
                                        <label htmlFor="">مایل به ارسال سند بصورت ایمیل هستید؟</label>
                                      </Col>
                                      <Col>
                                        <Switch
                                          onChange={() => {
                                            setIsEmail((prev) => !prev);
                                          }}
                                          checked={isEmail}
                                          size="large"
                                          className="switcherOpration"
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                </Col>
                              </Row>
                              {isEmail && (
                                <Row>
                                  <Col xxl={5}>
                                    <Form.Item
                                      className="input-normal"
                                      name="email"
                                      label="پست الکترونیکی"
                                      rules={[
                                        validateInput({
                                          t: t,
                                          validate: true,
                                          type: "email",
                                        }),
                                      ]}
                                    >
                                      <Input dir="ltr" inputMode="email" />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}
                            </Form>
                          </div>
                          <Row>
                            <Col xl={10} lg={24} style={{ margin: "auto" }}>
                              <div className="holder-signature-on-document">
                                <div ref={refBox} className="box-signature">
                                  {bgSingature?.length === 0 && (
                                    <>{printData !== null && <PrintDocument print={{ ...printData }} value={handleGetCanvas} canvas={true} />}</>
                                  )}
                                  <ReactSignatureCanvas
                                    penColor="blue"
                                    canvasProps={{
                                      id: "canvasDoc",
                                      width: "100%",
                                      height: "100%",
                                      className: "sigCanvas",
                                    }}
                                    clearOnResize={false}
                                    backgroundColor="transparent"
                                    onEnd={writeSignatureHandler}
                                  />
                                  <img src={bgSingature} alt="" width={"100%"} />
                                </div>
                                {hasErrorSign && <p style={{ color: "#ff4d4f" }}>لطفا فرم نمایش داده را امضا کنید</p>}
                                <div className="holder-button">
                                  <Button onClick={clearHandler} className="btn-normal">
                                    پاک کردن
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <div className="item-step">
                            <p>1- نسبت به چاپ سند اقدام فرمایید</p>
                            <Button
                              className="btn-normal btn-print"
                              type="default"
                              icon={<i className="icon-print"></i>}
                              onClick={() => {
                                window.print();
                                // setIsDisabled(false);
                              }}
                            >
                              چاپ سند
                            </Button>
                          </div>
                        </>
                      )}
                      <div className="item-step" style={{ display: signature ? "none" : "block" }}>
                        <p>2- سند مهر و امضا شده را بارگذاری کنید.</p>
                        <Row gutter={20}>
                          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Form
                              id="frmDocument"
                              onFinish={handleSubmit}
                              form={frmDocument}
                              onFinishFailed={() => {
                                setHasErrorSign(true);
                              }}
                              layout="vertical"
                            >
                              <Form.Item
                                name="photo"
                                rules={[
                                  {
                                    required: signature ? true : false,
                                    message: t("validation.required"),
                                  },
                                ]}
                                label="تصویر مدرک"
                              >
                                <ResizeImage exportImage={handleGetImage} />
                              </Form.Item>
                            </Form>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="g-footer-format-page">
                  <div className="holder-button">
                    <Button form="frmDocument" key="submit" htmlType="submit" className="btn-normal btn-aptel" type="primary" danger>
                      مرحله بعد
                    </Button>
                    <Button
                      className="btn-normal"
                      onClick={() => nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit)}
                      type="default"
                    >
                      بازگشت
                    </Button>
                  </div>
                </div>
              </div>
            </Content>
          </div>
        </div>

        <Loading isOpen={isLoading} />
      </DALayout>
    </>
  );
};

export default DADocument;
